import { render, staticRenderFns } from "./categorizeAndBrand.vue?vue&type=template&id=21630c3a&scoped=true"
import script from "./categorizeAndBrand.vue?vue&type=script&lang=js"
export * from "./categorizeAndBrand.vue?vue&type=script&lang=js"
import style0 from "./categorizeAndBrand.vue?vue&type=style&index=0&id=21630c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21630c3a",
  null
  
)

export default component.exports